<template>
  <header class="app-header">
    <router-link to="/" class="brand" title="Home">
      <img class="brand-logo" src="/favicon.svg" alt="Prody Block" />
      <span class="brand-name">Prody Block</span>
    </router-link>
    <nav class="pill-nav main-nav">
      <router-link
        v-for="item in items"
        :key="item.to"
        :to="item.to"
        :class="{ active: isActive(item) }"
      >
        {{ $t(item.label) }}
      </router-link>
    </nav>
    <div class="page-crumb" v-if="page">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="currentColor"
      >
        <path
          d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"
        />
      </svg>
      <span>{{ page }}</span>
    </div>
    <div class="header-center">
      <slot name="center"></slot>
    </div>
    <div class="header-right">
      <!-- Sits in every view, because a freeze can start anywhere. -->
      <ProcessPanel />
      <ProblemLog />
      <slot></slot>
    </div>
  </header>
</template>
<script>
import ProblemLog from "./ProblemLog.vue";
import ProcessPanel from "./ProcessPanel.vue";

export default {
  name: "HeaderBlock",
  components: { ProblemLog, ProcessPanel },
  props: {
    name: String,
    page: String,
  },
  data() {
    return {
      items: [
        { to: "/", label: "editor.home", exact: true },
        { to: "/editor", label: "editor.pages" },
        { to: "/pages", label: "editor.dynamic" },
        { to: "/menu", label: "editor.menus" },
        { to: "/translator", label: "editor.translate" },
        { to: "/seo", label: "editor.seo" },
      ],
    };
  },
  methods: {
    isActive(item) {
      if (item.exact) {
        return this.$route.path === item.to;
      }
      return this.$route.path.startsWith(item.to);
    },
  },
};
</script>
<style scoped>
.brand {
  text-decoration: none;
  color: inherit;
}
@media (max-width: 900px) {
  .main-nav a {
    padding: 6px 10px;
    font-size: 12px;
  }
}
</style>
